import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_b19f7eb2 from 'nuxt_plugin_sentryserver_b19f7eb2' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_4176cf1f from 'nuxt_plugin_sentryclient_4176cf1f' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_b48a1c7e from 'nuxt_plugin_plugin_b48a1c7e' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_vcurrencyfield_66c9d000 from 'nuxt_plugin_vcurrencyfield_66c9d000' // Source: ./v-currency-field.js (mode: 'all')
import nuxt_plugin_recaptcha_16460e5c from 'nuxt_plugin_recaptcha_16460e5c' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_3be68d8b from 'nuxt_plugin_cookieuniversalnuxt_3be68d8b' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_workbox_77a3c782 from 'nuxt_plugin_workbox_77a3c782' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_7082b452 from 'nuxt_plugin_metaplugin_7082b452' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_752a59c6 from 'nuxt_plugin_iconplugin_752a59c6' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_image_d44bde44 from 'nuxt_plugin_image_d44bde44' // Source: ./image.js (mode: 'all')
import nuxt_plugin_axios_aa59d83a from 'nuxt_plugin_axios_aa59d83a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginnuxt2client_4a7a8848 from 'nuxt_plugin_pluginnuxt2client_4a7a8848' // Source: ../../@nuxtjs/web-vitals/dist/runtime/plugin.nuxt2.client.mjs (mode: 'client')
import nuxt_plugin_nuxttypedvuex_6921c4fa from 'nuxt_plugin_nuxttypedvuex_6921c4fa' // Source: ./nuxt-typed-vuex.js (mode: 'all')
import nuxt_plugin_vmask_3801a64e from 'nuxt_plugin_vmask_3801a64e' // Source: ../../../plugins/v-mask (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../../../plugins/axios (mode: 'all')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../../../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_paramsToCookie_ca836d4a from 'nuxt_plugin_paramsToCookie_ca836d4a' // Source: ../../../plugins/paramsToCookie (mode: 'client')
import nuxt_plugin_auth_093d0ced from 'nuxt_plugin_auth_093d0ced' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Подать онлайн-заявку на кредит наличными во все банки сразу — Получить деньги срочно и без отказа","htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Одна заявка во все банки сразу — получить деньги в банке по всей России, решение по кредиту онлайн за 5 минут. Бесплатный сервис подбора кредита с высоким одобрением без комиссий"},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fmc.yandex.ru"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_b19f7eb2 === 'function') {
    await nuxt_plugin_sentryserver_b19f7eb2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_4176cf1f === 'function') {
    await nuxt_plugin_sentryclient_4176cf1f(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_b48a1c7e === 'function') {
    await nuxt_plugin_plugin_b48a1c7e(app.context, inject)
  }

  if (typeof nuxt_plugin_vcurrencyfield_66c9d000 === 'function') {
    await nuxt_plugin_vcurrencyfield_66c9d000(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_16460e5c === 'function') {
    await nuxt_plugin_recaptcha_16460e5c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_3be68d8b === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_3be68d8b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_77a3c782 === 'function') {
    await nuxt_plugin_workbox_77a3c782(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_7082b452 === 'function') {
    await nuxt_plugin_metaplugin_7082b452(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_752a59c6 === 'function') {
    await nuxt_plugin_iconplugin_752a59c6(app.context, inject)
  }

  if (typeof nuxt_plugin_image_d44bde44 === 'function') {
    await nuxt_plugin_image_d44bde44(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_aa59d83a === 'function') {
    await nuxt_plugin_axios_aa59d83a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginnuxt2client_4a7a8848 === 'function') {
    await nuxt_plugin_pluginnuxt2client_4a7a8848(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxttypedvuex_6921c4fa === 'function') {
    await nuxt_plugin_nuxttypedvuex_6921c4fa(app.context, inject)
  }

  if (typeof nuxt_plugin_vmask_3801a64e === 'function') {
    await nuxt_plugin_vmask_3801a64e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_paramsToCookie_ca836d4a === 'function') {
    await nuxt_plugin_paramsToCookie_ca836d4a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_093d0ced === 'function') {
    await nuxt_plugin_auth_093d0ced(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
